import { Component, input } from '@angular/core';

@Component({
  selector: 'cmg-info-row',
  imports: [],
  templateUrl: './info-row.component.html',
})
export class InfoRowComponent {
  label = input<string>('');
  value = input<string | number | null | undefined>('');
  alignBaseline = input<boolean>(true);
}
